module.exports = __webpack_public_path__ + "img/video3.dd481c93.svg";